import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AiApiSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: AiApiSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: AiApiSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<AiApiSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderApiUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Api Url</label>
          <Controller
            control={control}
            rules={{
              required: 'Api Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name="apiUrl"
            defaultValue={props.data?.apiUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Api Url"
                name={name}
                value={value}
                onChange={onChange}
                id="apiUrl"
              />
            )}
          />
          <ErrorMessage>{errors.apiUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderUsername = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Username</label>
          <Controller
            control={control}
            rules={{
              validate: {
                required: (value) => !!value || 'Username is required',
              },
            }}
            name="username"
            defaultValue={props.data?.username}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Username"
                name={name}
                value={value}
                onChange={onChange}
                id="username"
              />
            )}
          />
          <ErrorMessage>{errors.username?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderPassword = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Password</label>
          <Controller
            control={control}
            rules={{
              validate: {
                required: (value) => !!value || 'Password is required',
              },
            }}
            name="password"
            defaultValue={props.data?.password}
            render={({ onChange, value, name }) => (
              <input
                type="password"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Password"
                name={name}
                value={value}
                defaultValue={value}
                onChange={onChange}
                id="password"
              />
            )}
          />
          <ErrorMessage>{errors.password?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBrandName = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Brand Name</label>
          <Controller
            control={control}
            rules={{
              validate: {
                required: (value) => !!value || 'Brand Name is required',
              },
            }}
            name="brandName"
            defaultValue={props.data?.brandName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Brand Name"
                name={name}
                value={value}
                onChange={onChange}
                id="brandName"
              />
            )}
          />
          <ErrorMessage>{errors.brandName?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Ai Engine Api Settings</h4>
        <div className="row gutter-10">
          {renderApiUrl()}
          {renderUsername()}
          {renderPassword()}
          {renderBrandName()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
